module.exports = __webpack_public_path__ + "static/scale-model-of-dragon-park-gardens-in-dallas-texas-30ef1a9181583cdfa2453ec9dfcad2eb.png";